import * as React from 'react';
import styled from 'styled-components';

import { getColor, getFontSize, getShadow, getWidth, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { SidebarTab } from '@process-advisor/process-miner/shared/consts';
import { TabsTitles } from '@process-advisor/process-miner/navigation/sidebar/consts';

const Wrapper = styled.div<{ isActive: boolean ; $visible: boolean}>`
    position: relative;
    transform: translateX(${({ isActive }) => isActive ? 0 : -4}px);
    padding: 9px 12px 9px ${({ isActive }) => isActive ? 12 : 16}px;
    background-color: ${getColor('white')};
    cursor: pointer;
    transition: .2s;
    box-shadow: ${getShadow('tab')};
    width: ${getWidth('tab')}px;
    visibility: ${({ $visible }) => $visible ? 'visible' : 'hidden'};
    &:last-child {
        border-bottom-right-radius: 10px;
    }

    &:hover {
        transform: translateX(0);
        z-index: ${getZIndex('activeTab')};
    }
`;

const Text = styled.span`
    writing-mode: vertical-lr;
    font-size: 13px;
    font-weight: bold;
    color: ${getColor('blue')}
`;

type Props = {
    activeTab: SidebarTab,
    tab: SidebarTab,
    onClick: (tab: SidebarTab) => void
    visible: boolean,
    mode: string
}

export const Tab: React.FC<Props> = ({ tab, activeTab, visible, onClick, mode }) => (

    <div>
    {(mode === 'discovery_rules') ?
        <div>
        { TabsTitles[tab] === 'Model'  ?
            <Wrapper
                onClick={() => onClick(tab)}
                isActive={activeTab === tab}
                $visible={visible}>
                <Text>
                    {TabsTitles[tab].toUpperCase()}
                </Text>
            </Wrapper>
            :
            ''
        }
        </div>
    :
        <Wrapper
            onClick={() => onClick(tab)}
            isActive={activeTab === tab}
            $visible={visible}>
            <Text>
                {TabsTitles[tab].toUpperCase()}
            </Text>
        </Wrapper>
    }
    </div>

);
